<div class="portfolio-overlay"></div>
<div class="portfolio-content" tabindex="-1">
  <div role="tabpanel">
    <ul class="tabs portfolio-tabs" role="tablist">
      {{#each contents}}
        <li role="presentation" class="tab portfolio-tab {{#if @first}}active{{/if}}">
          <a href="#{{key}}_pane" id="{{key}}" role="tab" data-toggle="tab">{{t title}}</a>
        </li>
      {{/each}}
    </ul>
    <div class="tab-content portfolio-tab-content">
    </div>
  </div>
</div>
